module.exports = __webpack_public_path__ + "img/white01_128.41f8a589.png";